export interface Stock {
  statusCode: StockStatusCode | (string & {})
  statusAdditionalInfo?: string
  availableQuantity?: number
  availableStoreCount?: number
  stockAvailability?: string
}

export enum StockStatusCode {
  outOfStock = 'out-of-stock',
  inStock = 'in-stock',
  // Temporarily sold out, but can be ordered from warehouse
  backorder = 'backorder',
  // Sales not started yet
  preorder = 'preorder',
}
